import React, { useState } from "react";
import axios, { AxiosError } from "axios";

const MAX_SIZE = 10 * 1024; // 10 KB

function DocketWiseKycUpload() {
  const [ticketNo, setTicketNo] = useState<string>("");
  const [kyc1, setKyc1] = useState<File | null>(null);
  const [kyc2, setKyc2] = useState<File | null>(null);
  const [loading, setLoading] = useState<boolean>(false);

  const handleFileChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    setFile: React.Dispatch<React.SetStateAction<File | null>>
  ) => {
    const file = e.target.files?.[0];
    if (!file) return;

    if (file.type !== "image/png") {
      alert("Only PNG image allowed");
      e.target.value = "";
      return;
    }

    if (file.size > MAX_SIZE) {
      alert("Image must be 10KB or less");
      e.target.value = "";
      return;
    }

    setFile(file);
  };

  const handleSubmit = async () => {
    if (!ticketNo) {
      alert("Ticket No required");
      return;
    }

    const formData = new FormData();
    formData.append("Ticket_No", ticketNo);
    if (kyc1) formData.append("KYC1", kyc1);
    if (kyc2) formData.append("KYC2", kyc2);

    try {
      setLoading(true);
      const res = await axios.post(
        "http://localhost:3000/api/upload-kyc",
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );

      alert(res.data.Message);
    } catch (err) {
      const error = err as AxiosError<{ Message: string }>;
      alert(error.response?.data?.Message || "Upload failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ padding: 20 }}>
      <h3>KYC Upload (PNG ≤ 10KB)</h3>

      <input
        type="text"
        placeholder="Ticket No"
        value={ticketNo}
        onChange={(e) => setTicketNo(e.target.value)}
      />
      <br />
      <br />

      <label>KYC1 (PNG, max 10KB)</label>
      <br />
      <input
        type="file"
        accept="image/png"
        onChange={(e) => handleFileChange(e, setKyc1)}
      />
      <br />
      <br />

      <label>KYC2 (PNG, max 10KB)</label>
      <br />
      <input
        type="file"
        accept="image/png"
        onChange={(e) => handleFileChange(e, setKyc2)}
      />
      <br />
      <br />

      <button onClick={handleSubmit} disabled={loading}>
        {loading ? "Uploading..." : "Upload"}
      </button>
    </div>
  );
}

export default DocketWiseKycUpload;
